<template>
  <b-container fluid v-if="$root.$data.me.AllowAnalytics">
    <b-row v-if="!apOptions || apOptions.length === 0">
      <b-col>
        <template v-if="apOptions === null && !apError">
          Ophalen van beschikbare periodes <b-spinner label="Laden"></b-spinner>
        </template>

        <span v-if="apOptions && apOptions.length === 0">Geen gegevens beschikbaar</span>
        <span v-if="apError">{{ apError }}</span>
      </b-col>
    </b-row>
    <b-row v-if="apOptions && apOptions.length > 0">
      <b-col>
        <page-snippet name="analytics" />
        <b-card>
          <div slot="header">
            Filters / Opties
          </div>

          <b-container fluid class="p-0" >
            <b-row>
              <b-col cols="12" md="6" lg="6" xl="4" class="mb-4">
                <div class="mr-2">Bekijk:</div>
                <b-button-group>
                  <b-button
                      v-on:click="view = 'top-lists'; target = 'Quantity'; filterSerial++"
                      v-bind:class="{ active: view == 'top-lists' && target == 'Quantity'}">
                    <span v-if="sortDirection == 'desc'">Top</span> 
                    <span v-if="sortDirection == 'asc'">Bodem</span> 
                    aantal
                  </b-button>
                  <b-button
                      v-on:click="view = 'top-lists'; target = 'ProviderIncome'; filterSerial++"
                      v-bind:class="{ active: view == 'top-lists' && target == 'ProviderIncome' }">
                    <span v-if="sortDirection == 'desc'">Top</span> 
                    <span v-if="sortDirection == 'asc'">Bodem</span> 
                    inkomsten
                  </b-button>
                  <b-button 
                      v-on:click="view = 'table'"
                      v-bind:class="{ active: view == 'table' }">
                   Bekijk/exporteer transacties
                  </b-button>
                </b-button-group>
              </b-col>

              <b-col cols="12" md="6" lg="6" xl="4" class="mb-4" v-if="false">
                <div class="mr-2">Sorteer:</div>
                <b-button-group>
                  <b-button
                      v-on:click="sortDirection = 'asc'"
                      v-bind:class="{ active: sortDirection == 'asc'}">
                    Oplopend
                  </b-button>
                  <b-button
                      v-on:click="sortDirection = 'desc'"
                      v-bind:class="{ active: sortDirection == 'desc'}">
                    Aflopend
                  </b-button>
                </b-button-group>
              </b-col>

              <b-col cols="12" md="6" lg="6" xl="4" class="mb-4">
                <div class="mr-2">Periode:</div>

                <span class="mt-2">
                  <b-form-select v-model="filter.apFrom" :options="apOptions" size="sm" class="mr-2"></b-form-select>
                  - 
                  <b-form-select v-model="filter.apTo" :options="apOptions" size="sm" class="mr-2"></b-form-select>
                </span>
              </b-col>

              <b-col cols="12" md="6" lg="6" xl="4" class="mb-4">
                <div class="mr-2">Resultaten:</div>

                <b-button-group class="mr-2">
                  <b-button
                      v-on:click="perPage = 5"
                      v-bind:class="{ active: perPage == 5 }">
                    5
                  </b-button>
                  <b-button
                      v-on:click="perPage = 10"
                      v-bind:class="{ active: perPage == 10 }">
                    10
                  </b-button>
                  <b-button
                      v-on:click="perPage = 25"
                      v-bind:class="{ active: perPage == 25 }">
                    25
                  </b-button>
                </b-button-group>
              </b-col>

              <b-col cols="12" md="6" lg="6" xl="4" class="mb-4">
                Nummer formaat:<br>
                <b-button-group class="mr-2">
                  <b-button
                      v-on:click="numberLocale = 'intl'"
                      v-bind:class="{ active: numberLocale == 'intl' }">
                    1 000.00
                  </b-button>
                  <b-button
                      v-on:click="numberLocale = 'en'"
                      v-bind:class="{ active: numberLocale == 'en' }">
                    1,000.00
                  </b-button>
                  <b-button
                      v-on:click="numberLocale = 'nl'"
                      v-bind:class="{ active: numberLocale == 'nl' }">
                    1.000,00
                  </b-button>
                </b-button-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="6" lg="4" xl="4" class="mb-4">
                Tracks:
                <ApiLookup v-model="filter.selectedTracks" source="analytics/find-tracks" :filter="filter" :context="'RoyaltyTransactions'" />
              </b-col>

              <b-col cols="12" md="6" lg="4" xl="4"  class="mb-4">
                Albums:
                <ApiLookup v-model="filter.selectedAlbums" source="analytics/find-albums" :filter="filter" :context="'RoyaltyTransactions'" />
              </b-col>

              <b-col cols="12" md="6" lg="4" xl="4"  class="mb-4">
                Uitvoerend artiest:
                <ApiLookup v-model="filter.selectedAttributions" source="analytics/find-attributions" :filter="filter" :context="'RoyaltyTransactions'" />
              </b-col>
              
              <b-col cols="12" md="6" lg="4" xl="4"  class="mb-4">
                Portals:
                <ApiLookup v-model="filter.selectedOutlets" source="analytics/find-outlets" :filter="filter" :context="'RoyaltyTransactions'" />
              </b-col>

              <b-col cols="12" md="6" lg="4" xl="4"  class="mb-4">
                Landen:
                <ApiLookup v-model="filter.selectedCountries" source="analytics/find-countries" :filter="filter" :context="'RoyaltyTransactions'" />
              </b-col>

              <b-col cols="12" md="6" lg="4" xl="4"  class="mb-4">
                Label
                <ApiLookup v-model="filter.selectedRefs" source="analytics/find-statement-refs" :filter="filter"  />
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-button variant="primary" class="mr-2" v-on:click="filterSerial++">Toepassen</b-button>
                <b-button variant="secondary" v-on:click="clearFilters">Leeg maken</b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="view == ''" class="mt-4">
      <b-col>
        <b-alert show>Kies bovenaan een optie: "Top aantal", "Top inkomsten" or "Bekijk/exporteer transacties"</b-alert>
      </b-col>
    </b-row>

    <b-row class="mt-4" v-if="view == 'table' && apOptions.length > 0">
      <b-col>
        <RoyaltyTransactionTable v-on:item-click="filterItem($event)" :watch="filterSerial" :filter="filter" :perPage="perPage" :numberLocale="numberLocale" :sortDirection="sortDirection" />
      </b-col>
    </b-row>

    <b-row v-if="view == 'top-lists' && apOptions.length > 0">
      <b-col class="mt-4" cols="12" md="6" lg="4" xl="3"><RoyaltyAnalyticsList :sortDirection="sortDirection" :canSelect="true" v-on:item-click="filterItem($event)" :watch="filterSerial" :numberLocale="numberLocale" :filter="filter" :target="target" :perPage="perPage" aggName="track" title="Tracks" columnTitle="Track" /></b-col>
      <b-col class="mt-4" cols="12" md="6" lg="4" xl="3"><RoyaltyAnalyticsList :sortDirection="sortDirection" :canSelect="true" v-on:item-click="filterItem($event)" :watch="filterSerial" :numberLocale="numberLocale" :filter="filter" :target="target" :perPage="perPage" aggName="album" title="Albums" columnTitle="Album" /></b-col>
      <b-col class="mt-4" cols="12" md="6" lg="4" xl="3"><RoyaltyAnalyticsList :sortDirection="sortDirection" :canSelect="true" v-on:item-click="filterItem($event)" :watch="filterSerial" :numberLocale="numberLocale" :filter="filter" :target="target" :perPage="perPage" aggName="attribution" title="Artiest" columnTitle="Artiest" /></b-col>
      <b-col class="mt-4" cols="12" md="6" lg="4" xl="3"><RoyaltyAnalyticsList :sortDirection="sortDirection" :canSelect="true" v-on:item-click="filterItem($event)" :watch="filterSerial" :numberLocale="numberLocale" :filter="filter" :target="target" :perPage="perPage" aggName="reference" title="Labels" columnTitle="Label" /></b-col>
      <b-col class="mt-4" cols="12" md="6" lg="4" xl="3"><RoyaltyAnalyticsList :sortDirection="sortDirection" :canSelect="true" v-on:item-click="filterItem($event)" :watch="filterSerial" :numberLocale="numberLocale" :filter="filter" :target="target" :perPage="perPage" aggName="outlet" title="Portals" columnTitle= "Portal" /></b-col>
      <b-col class="mt-4" cols="12" md="6" lg="4" xl="3"><RoyaltyAnalyticsList :sortDirection="sortDirection" :canSelect="true" v-on:item-click="filterItem($event)" :watch="filterSerial" :numberLocale="numberLocale" :filter="filter" :target="target" :perPage="perPage" aggName="country" title="Landen" columnTitle= "Land" /></b-col>
      <b-col class="mt-4" cols="12" md="6" lg="4" xl="3"><RoyaltyAnalyticsList :sortDirection="sortDirection" :canSelect="true" v-on:item-click="filterItem($event)" :watch="filterSerial" :numberLocale="numberLocale" :filter="filter" :target="target" :perPage="perPage" aggName="accountingPeriod" title="Periodes" columnTitle="Periode" /></b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: 'RoyaltyAnalytics',
    components: {
        RoyaltyAnalyticsList: () => import('@/components/RoyaltyAnalyticsList.vue'),
        RoyaltyTransactionTable: () => import('@/components/RoyaltyTransactionTable.vue'),
        ApiLookup: () => import('@/components/ApiLookup.vue'),
        'page-snippet': () => import('@/components/PageSnippet.vue')
    },
    data () {
      return {
        filterSerial: 1,
        sortDirection: 'desc',
        filter: {
          apFrom: '',
          apTo: '',
          selectedTracks: [],
          selectedAlbums: [],
          selectedAttributions: [],
          selectedRefs: [],
          selectedOutlets: [],
          selectedCountries: [],
        },
        trendsLoading: false,
        target: 'ProviderIncome',
        perPage: 5,
        apOptions: null,
        numberLocale: 'nl',
        view: '',
      }
    },
    props: {
      inputParams: Object
    },
    methods: {
      filterItem (data) {
        let item = data.item
        if (data.type == 'album') {
          this.filter.selectedAlbums.push({key: item.key, value: item.title})
        } else if (data.type == 'track') {
          this.filter.selectedTracks.push({key: item.key, value: item.title})
        } else if (data.type == 'reference') {
          this.filter.selectedRefs.push({key: item.key, value: item.title})
        } else if (data.type == 'outlet') {
          this.filter.selectedOutlets.push({key: item.key, value: item.title})
        } else if (data.type == 'country') {
          this.filter.selectedCountries.push({key: item.key, value: item.title})
        } else if (data.type == 'attribution') {
          this.filter.selectedAttributions.push({key: item.key, value: item.title})
        } else if (data.type == 'accountingPeriod') {
          this.filter.apFrom = item.key
          this.filter.apTo = item.key
        }
      },
      clearFilters () {
        this.clearArray(this.filter.selectedCountries)
        this.clearArray(this.filter.selectedTracks)
        this.clearArray(this.filter.selectedAlbums)
        this.clearArray(this.filter.selectedRefs)
        this.clearArray(this.filter.selectedOutlets)
        this.clearArray(this.filter.selectedAttributions)
      },
      clearArray(arr) {
        while (arr.length > 0)
          arr.pop()
      }
    },
    computed: {
    },
    mounted () {
      this.$root.$data.crumbs = [
        {to: { name: 'royalty-analytics' }, text: 'Royalty analytics'}
      ]

      let params = this.$route.query
      if (params.view)
        this.view = params.view

      if (params.statementRefs) {
        params.statementRefs.split(',').forEach(item => {
          this.filter.selectedRefs.push({
            key: item,
            value: item
          })
        })
      }

      if (params.tracks) {
        params.tracks.split(',').forEach(item => {
          this.filter.selectedTracks.push({
            key: item,
            value: item
          })
        })
      }
      
      if (params.albums) {
        params.albums.split(',').forEach(item => {
          this.filter.selectedAlbums.push({
            key: item,
            value: item
          })
        })
      }
      
      this.$http
        .get('analytics/accounting-periods')
        .then(response => {
          let result = response.data
          this.apOptions = []
          result.forEach(item => {
            this.apOptions.push({
              value: item.id,
              text: item.description
            })
          })
          
          if (params.accountingPeriod) {
            this.filter.apFrom = params.accountingPeriod
            this.filter.apTo = params.accountingPeriod
          } else {
            this.filter.apFrom = this.apOptions[this.apOptions.length-1].value
            this.filter.apTo = this.filter.apFrom
          }
          this.filterSerial++
        })
    }
  }
</script>

<style scoped>
  .btn { white-space: nowrap; }

  .custom-select {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
</style>
